const getSectionInView = () => {
  const sections = Array.from(document.querySelectorAll('section'));

  // reverse the sections to find the section we want from ' bottom up '
  const sectionsReversed = sections.slice().reverse();

  //
  const section: any = sectionsReversed.find((i: any) => {
    const { height, top } = i.getBoundingClientRect();

    // if height ( is not 0 ). to ignore sections not yet rendered into view
    if (height && top < window.innerHeight / 2) {
      return i;
    }
  });

  return {
    sections,
    section,
    index: sections.indexOf(section),
  };
};

export default getSectionInView;
